export const about_ketto = {
  about: `Ketto.org is an online crowdfunding platform that supports the treatment of various poor & needy patients especially children. Since many of them are unable to afford their life-saving bills, the power of crowdfunding helps make it happen. Till date, Ketto with the help of 10,00,000+ generous contributors like you who contributed towards the medical cause managed to save the lives of 90,000+ patients. We've raised  Rs. 250+ Crore that helped pay for the crucial treatment of patients suffering from Cancer, heart-diseases, Thalassemia, transplants & more.`,
  position: '-10px -245px'
};
export function how_it_works(data) {
  return [
    {
      title: 'Patient seeks care',
      desc: `${data?.patient} is brought to one of our medical partners ${data?.hospital}`,
      position: '9px -180px'
    },
    {
      title: `Medical Partner submits Patient’s case to Ketto`,
      desc: `${data?.beneficiary}’s profile is sent to us. We review and approve the case and start fundraising for ${data?.patient}.`,
      position: '9px -380px'
    },
    {
      title: `Contributors fund Patient’s care`,
      desc: `Generous people like you provide generous contributions which is provided directly to our medical partner ${data?.hospital} for ${data?.patient}’s care.`,
      position: '9px -787px'
    },
    {
      title: `Get notified on your Contribution Impact`,
      desc: `Medical Partner ${data?.hospital} and Patient’s family provide a post treatment update on ${data?.patient} and we send it to his/her contributors.`,
      position: '9px -586px'
    },
  ];
}

export function how_it_works_k_cart() {
  return [
    {
      title: 'A fundraiser is started.',
      desc: `NGOs or individuals in pressing need initiate their fundraising journey by submitting the required details to our online platform.`,
      position: '0px -183px;'
    },
    {
      title: `The fundraiser is approved and goes live.`,
      desc: `After KYC is completed, Ketto reviews and verifies all of the case details. Once approved, the fundraiser goes live on our platform, detailing the story and listing the specific products needed, such as medicines, food, and other essentials.`,
      position: '0px -183px'
    },
    {
      title: `Our community comes together to offer support.`,
      desc: `Generous giver like you can support the campaign by pledging the required products instead of cash. Pledges are made through our secure platform, where you can choose and purchase the specific items needed. The products are then sent directly to the partner to ensure their needs are promptly met.`,
      position: '0px -365px'
    },
    {
      title: `Supporters receive regular updates on the impact of their kindness.`,
      desc: `We maintain transparency throughout the process, providing detailed reports on the utilization of products and outcomes.`,
      position: '0px -555px'
    },
  ];
}

export function how_non_medical(data) {
  return [
    {
      title: 'NGO seeks support',
      desc: `${data?.beneficiary} reaches out to us through an ${data?.manager}`,
      position: '9px -180px'
    },
    {
      title: `${data?.manager} submits NGO’s case to Ketto`,
      desc: `${data?.beneficiary}’s profile is sent to us. We review and approve the case after verification. A fundraising for ${data?.beneficiary} is started soon after the verification is completed`,
      position: '9px -380px'
    },
    {
      title: `Contributors fund the NGO`,
      desc: `Kind people like you make generous contributions which are directly provided to our ${data?.beneficiary}.`,
      position: '9px -787px'
    },
    {
      title: `Get notified on your Contribution Impact`,
      desc: `The ${data?.beneficiary} provides a thorough update on how they have helped the society and we send it to his/her contributors.`,
      position: '9px -586px'
    },
  ];
}
